import { useEffect, useState } from "react";
import * as Bowser from "bowser";

const useIsPlatformMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const supportsOrientationChange = "onorientationchange" in window;
    const orientationEvent = supportsOrientationChange
      ? "orientationchange"
      : "resize";
    const detectMobile = () => {
      const browser = Bowser.getParser(window.navigator.userAgent);
      const platformType = browser.getPlatformType(true);

      const fallbackIsMobile =
        /Mobi|Android|iPhone|iPad|iPod/.test(navigator.userAgent) ||
        (window.innerWidth < 768 && "ontouchstart" in window);

      const isMobile = platformType === "mobile" || fallbackIsMobile;

      setIsMobile(isMobile);
    };

    window.addEventListener(orientationEvent, detectMobile);
    detectMobile();

    return () => {
      window.removeEventListener(orientationEvent, detectMobile);
    };
  }, []);

  return isMobile;
};

export default useIsPlatformMobile;
